import { render } from "./BaseSelectPhone.vue?vue&type=template&id=62ec9584&scoped=true"
import script from "./BaseSelectPhone.vue?vue&type=script&lang=js"
export * from "./BaseSelectPhone.vue?vue&type=script&lang=js"

import "./BaseSelectPhone.vue?vue&type=style&index=0&id=62ec9584&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62ec9584"]])

export default __exports__